module.exports = __webpack_public_path__ + "static/assets/10be8b0220e39ecfa4566e612b12c29e.svg";